import { render } from "./AlmStatusBadge.vue?vue&type=template&id=9c661228&ts=true"
import script from "./AlmStatusBadge.vue?vue&type=script&lang=ts"
export * from "./AlmStatusBadge.vue?vue&type=script&lang=ts"

import "./AlmStatusBadge.vue?vue&type=style&index=0&id=9c661228&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__